<template>
   <div id="reservas">
      <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
      <div class="card">
         <div class="card-body">
            <h4 class="fw-bolder mb-4">
               Detalle de reserva
               <span v-if="reserva != null" class="fw-bold text-info">{{
                  reserva.cod_reserva
               }}</span>
            </h4>

            <div class="float-end">
               <button
                  @click="confirmCheck"
                  v-if="permisoRevision"
                  class="btn btn-sm"
                  :class="
                     reserva?.revisada == 1
                        ? 'btn-success'
                        : 'btn-outline-success'
                  "
               >
                  <span v-if="reserva?.revisada == 0">
                     <i class="fa fa-times"></i> <br />
                     Sin revisar
                  </span>
                  <span v-if="reserva?.revisada == 1">
                     <i class="fa fa-check"></i> <br />
                     Revisada
                  </span>
               </button>
            </div>
            <div v-if="loading" class="text-center">
               <div class="loadingio-spinner-ripple-6armq16mc04">
                  <div class="ldio-2tzb8vdk7pu">
                     <div></div>
                     <div></div>
                  </div>
               </div>
            </div>
            <div v-else>
               <div v-if="reserva != null">
                  <div
                     v-if="reserva.estado == 3"
                     class="alert alert-danger fw-bold"
                  >
                     <i class="fa fa-exclamation-circle"></i> Reserva anulada.
                  </div>
                  <div class="mb-3">
                     <button
                        v-if="
                           reserva.estado != 1 && reserva.estado != 3 && permiso
                        "
                        data-bs-toggle="modal"
                        data-bs-target="#aprobar_reserva"
                        class="btn btn-success btn-sm"
                        :disabled="reserva.saldo > 0"
                     >
                        <i class="fa fa-check-circle"></i> <br />
                        Aprobar reserva
                     </button>

                     <button
                        class="btn btn-success btn-sm ms-1"
                        data-bs-toggle="modal"
                        data-bs-target="#generarVouchers"
                        :disabled="reserva.saldo > 0"
                     >
                        <i class="fa fa-file-contract"></i> <br />
                        Generar Vouchers
                     </button>

                     <button
                        v-if="permiso"
                        @click="validarValorBono"
                        data-bs-toggle="modal"
                        data-bs-target="#crearBono"
                        class="btn btn-success btn-sm ms-1"
                        :disabled="reserva.totalSaldoBonos >= reserva.total"
                     >
                        <i class="fa fa-ticket"></i> <br />
                        Crear bono
                     </button>

                     <button
                        v-if="reserva.estado != 3"
                        data-bs-toggle="modal"
                        data-bs-target="#enviar_email"
                        class="btn btn-info btn-sm ms-1"
                     >
                        <i class="fa-solid fa-envelope"></i> <br />
                        Enviar email
                     </button>
                     <button
                        v-if="permiso && reserva.estado != 3"
                        data-bs-toggle="modal"
                        data-bs-target="#anular"
                        class="btn btn-outline-danger btn-sm ms-1"
                     >
                        <i class="fa-solid fa-trash"></i> <br />
                        Anular
                     </button>
                  </div>
                  <h5 class="fw-bolder text-muted">Información básica</h5>
                  <div class="card card-body shadow">
                     <div class="row">
                        <div class="col-lg-3">
                           <div>
                              <small>Fecha de registro</small>
                              <h6 class="text-primary fw-bolder">
                                 {{ reserva.fecha_reg }}
                              </h6>
                           </div>
                        </div>
                        <div class="col-lg-3">
                           <small>Cliente</small>
                           <h6
                              class="text-primary text-uppercase fw-bolder mb-0"
                           >
                              {{ reserva.cliente.nombres }}
                              {{ reserva.cliente.apellidos }}
                           </h6>
                           <small>
                              <span>{{ reserva.cliente.email }}</span
                              ><br />
                              <span>{{ reserva.cliente.telefono }}</span>
                           </small>
                        </div>
                        <div class="col-lg-3">
                           <div v-if="reserva.comprador != null">
                              <small>Comprador</small>
                              <h6
                                 class="text-primary text-uppercase fw-bolder mb-0"
                              >
                                 {{ reserva.comprador.nombres }}
                                 {{ reserva.comprador.apellidos }}
                              </h6>
                              <small>
                                 <span>{{ reserva.comprador.email }}</span
                                 ><br />
                                 <span>{{ reserva.comprador.telefono }}</span>
                              </small>
                           </div>
                        </div>
                        <div class="col-lg-3">
                           <small>Estado</small>
                           <h6 class="fw-bolder">
                              <span
                                 v-if="reserva.estado == 0"
                                 class="text-warning"
                                 >Pendiente</span
                              >
                              <span
                                 v-if="reserva.estado == 1"
                                 class="text-success"
                                 >Aprobada</span
                              >
                              <span
                                 v-if="reserva.estado == 2"
                                 class="text-danger"
                                 >Anulada</span
                              >
                           </h6>
                        </div>
                     </div>
                  </div>
                  <h5 class="fw-bolder text-muted mt-3">Servicios</h5>
                  <div
                     class="card card-body shadow mt-3"
                     v-for="(servicio, index_servicio) in reserva.servicios"
                     v-bind:key="index_servicio"
                  >
                     <div class="mb-2">
                        <span class="text-muted fw-bold">
                           <small>ID: {{ servicio.id_servicio_reserva }}</small>
                        </span>
                     </div>
                     <div v-if="servicio.tipo == 1">
                        <div class="mb-2">
                           <span class="fw-bold text-muted">
                              <i class="fa-solid fa-map"></i> Actividad
                           </span>
                        </div>
                        <div class="row">
                           <div class="col-lg-4">
                              <small class="text-muted">Actividad</small>
                              <h6 class="text-primary">
                                 {{ servicio.servicio.codigo }} -
                                 {{ servicio.servicio.servicio }}
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Pasajeros</small>
                              <h6 class="text-primary" style="font-size: 0.8em">
                                 {{ servicio.adultos }} adultos -
                                 {{ servicio.ninos }} niños -
                                 {{ servicio.infantes }} infantes
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Fecha</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_actividad.f }}
                              </h6>
                           </div>
                           <div
                              v-if="servicio.horario != null"
                              class="col-lg-2"
                           >
                              <small class="text-muted">Horario</small>
                              <h6 class="text-primary">
                                 {{ servicio.horario.desde }}
                              </h6>
                           </div>
                           <div class="col-lg-2 text-end">
                              <small class="text-muted">Valor venta</small>
                              <h6 class="text-primary">
                                 {{ servicio.valor_venta | currency }}
                              </h6>
                           </div>
                        </div>
                     </div>
                     <div
                        v-if="
                           servicio.tipo == 2 ||
                           servicio.tipo == 4 ||
                           servicio.tipo == 5
                        "
                     >
                        <div class="mb-2">
                           <span
                              v-if="servicio.tipo == 2"
                              class="fw-bold text-muted"
                           >
                              <i class="fa-solid fa-box"></i> Paquete
                           </span>
                           <span
                              v-if="servicio.tipo == 4"
                              class="fw-bold text-muted"
                           >
                              <i class="fa-solid fa-plane-departure"></i>
                              Tiquete
                              {{ servicio.tipo_tiquete }}
                              <small v-if="servicio.plan == 1">
                                 - Pertenece a plan</small
                              >
                           </span>
                           <span
                              v-if="servicio.tipo == 5"
                              class="fw-bold text-muted"
                           >
                              <i class="fa-solid fa-user-doctor"></i> Asistencia
                              médica
                              <small v-if="servicio.plan == 1">
                                 - Pertence a plan</small
                              >
                           </span>
                        </div>
                        <div class="row">
                           <div class="col-lg-4">
                              <small class="text-muted">Origen - Destino</small>
                              <h6 class="text-primary mb-0">
                                 {{ servicio.origen.ciudad_pais }} -
                                 {{ servicio.destino.ciudad_pais }}
                              </h6>
                              <small class="fw-bold text-primary">{{
                                 servicio.proveedor.proveedor
                              }}</small>
                           </div>
                           <div class="col-lg-2 text-center">
                              <small class="text-muted">Pasajeros</small>
                              <h6 class="text-primary">
                                 {{ servicio.num_pasajeros }}
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Fecha ida</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_ida.f }}
                              </h6>
                           </div>
                           <div
                              v-if="
                                 servicio.tipo == 2 ||
                                 servicio.tipo == 5 ||
                                 servicio.tipo_tiquete == 'RT'
                              "
                              class="col-lg-2"
                           >
                              <small class="text-muted">Fecha regreso</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_regreso.f }}
                              </h6>
                           </div>
                           <div class="col-lg-2 text-end">
                              <small class="text-muted">Valor venta</small>
                              <h6 class="text-primary">
                                 {{ servicio.valor_venta | currency }}
                              </h6>
                           </div>
                        </div>
                     </div>
                     <div v-if="servicio.tipo == 3">
                        <div class="mb-2">
                           <span class="fw-bold text-muted">
                              <i class="fa-solid fa-bed"></i> Hospedaje
                           </span>
                        </div>
                        <div class="row">
                           <div class="col-lg-4">
                              <small class="text-muted">Hotel</small>
                              <h6 class="text-primary">
                                 {{ servicio.servicio.servicio }}
                              </h6>
                           </div>
                           <div class="col-lg-2 text-center">
                              <small class="text-muted">Pasajeros</small>
                              <h6 class="text-primary">
                                 {{ servicio.num_pasajeros }}
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Fecha ida</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_ida.f }}
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Fecha regreso</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_regreso.f }}
                              </h6>
                           </div>
                           <div class="col-lg-2 text-end">
                              <small class="text-muted">Valor venta</small>
                              <h6 class="text-primary">
                                 {{ servicio.valor_venta | currency }}
                              </h6>
                           </div>
                        </div>
                     </div>
                     <div v-if="servicio.tipo == 6">
                        <div class="mb-2">
                           <span class="fw-bold text-muted">
                              <i class="fa-solid fa-file"></i> Otros servicios
                           </span>
                        </div>
                        <div class="row">
                           <div class="col-lg-4">
                              <small class="text-muted">Descripción</small>
                              <h6 class="text-primary">
                                 {{ servicio.servicio.codigo }} -
                                 {{ servicio.descripcion }}
                              </h6>
                           </div>
                           <div class="col-lg-2">
                              <small class="text-muted">Pasajeros</small>
                              <h6 class="text-primary" style="font-size: 0.8em">
                                 {{ servicio.adultos }} adultos -
                                 {{ servicio.ninos }} niños -
                                 {{ servicio.infantes }} infantes
                              </h6>
                           </div>
                           <div
                              v-if="servicio.fecha_actividad != null"
                              class="col-lg-2"
                           >
                              <small class="text-muted"
                                 >Fecha actividad / Fecha ida</small
                              >
                              <h6 class="text-primary">
                                 {{ servicio.fecha_actividad.f }}
                              </h6>
                           </div>
                           <div
                              v-if="servicio.fecha_regreso != null"
                              class="col-lg-2"
                           >
                              <small class="text-muted">Fecha regreso</small>
                              <h6 class="text-primary">
                                 {{ servicio.fecha_regreso.f }}
                              </h6>
                           </div>
                           <div class="col-lg-2 text-end">
                              <small class="text-muted">Valor venta</small>
                              <h6 class="text-primary">
                                 {{ servicio.valor_venta | currency }}
                              </h6>
                           </div>
                        </div>
                        <div
                           v-if="
                              servicio.incluye != null || servicio.incluye != ''
                           "
                           class="row"
                        >
                           <div class="col-12">
                              <small class="text-muted">Incluye</small>
                              <div
                                 v-html="servicio.incluye"
                                 class="bg-light p-2 rounded mt-0 mb-2"
                              ></div>
                           </div>
                        </div>
                     </div>
                     <div
                        v-if="
                           permiso ||
                           reserva.id_usuario ==
                              session.usuario.usuario.id_usuario
                        "
                        class="text-end mt-3 mb-3"
                     >
                        <small class="text-muted"
                           >Valor comisión servicio</small
                        >
                        <h6 class="text-success">
                           {{ servicio.comision | currency }}
                        </h6>
                     </div>
                     <div class="text-end mt-1">
                        <div class="btn-group">
                           <button
                              type="button"
                              class="btn btn-success rounded-pill p-2 dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                           >
                              <i class="fa fa-list"></i>
                              Opciones
                           </button>
                           <ul class="dropdown-menu">
                              <li>
                                 <a
                                    v-if="permiso && reserva.estado != 3"
                                    v-on:click="load_edicion(index_servicio)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#editar_servicio"
                                    class="dropdown-item fw-bolder"
                                    href="javascript:void(0)"
                                 >
                                    <i class="fa fa-edit"></i> Editar servicio
                                 </a>
                              </li>
                              <li>
                                 <a
                                    v-if="reserva.estado != 3"
                                    @click="index_servicio_sel = index_servicio"
                                    data-bs-toggle="modal"
                                    data-bs-target="#vouchers"
                                    class="dropdown-item fw-bolder"
                                    href="javascript:void(0)"
                                 >
                                    <i class="fa-solid fa-file"></i> Vouchers</a
                                 >
                              </li>
                              <li>
                                 <a
                                    v-if="permiso"
                                    @click="index_servicio_sel = index_servicio"
                                    data-bs-toggle="modal"
                                    data-bs-target="#recaudos"
                                    class="dropdown-item fw-bolder"
                                    href="#"
                                 >
                                    <i
                                       class="fa-solid fa-file-invoice-dollar"
                                    ></i>
                                    Recaudos
                                 </a>
                              </li>
                              <li>
                                 <a
                                    v-if="permiso"
                                    @click="index_servicio_sel = index_servicio"
                                    data-bs-toggle="modal"
                                    data-bs-target="#pagosProveedor"
                                    class="dropdown-item fw-bolder"
                                    href="#"
                                 >
                                    <i
                                       class="fa-solid fa-file-invoice-dollar"
                                    ></i>
                                    Pagos a proveedor
                                 </a>
                              </li>
                              <li>
                                 <a
                                    v-if="
                                       reserva.servicios.length > 1 && permiso
                                    "
                                    v-on:click="servicio_sel = servicio"
                                    data-bs-toggle="modal"
                                    data-bs-target="#eliminar_servicio"
                                    class="dropdown-item fw-bolder"
                                    href="javascript:void(0)"
                                 >
                                    <i class="fa fa-trash"></i> Eliminar
                                    servicio</a
                                 >
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div
                     v-if="
                        permiso ||
                        reserva.id_usuario == session.usuario.usuario.id_usuario
                     "
                     class="text-end mt-3 mb-3 card card-body shadow"
                  >
                     <small class="text-muted">Total comisión reserva</small>
                     <h6 class="text-success">
                        {{ reserva.totalComision | currency }}
                     </h6>
                  </div>
                  <h5 class="fw-bolder text-muted mt-3">Pasajeros</h5>
                  <div class="card card-body shadow">
                     <div class="text-end">
                        <button
                           data-bs-toggle="modal"
                           data-bs-target="#pasajeros"
                           class="btn btn-primary btn-sm rounded-pill"
                        >
                           <i class="fa fa-users"></i> Pasajeros
                        </button>
                     </div>
                     <div v-if="reserva.pasajeros.length != 0">
                        <table
                           class="table table-hover table-condensed my_table_2"
                        >
                           <thead>
                              <tr>
                                 <th>Nombres y apellidos</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(
                                    pasajero, index_pasajero
                                 ) in reserva.pasajeros"
                                 v-bind:key="index_pasajero"
                              >
                                 <td class="fw-bolder text-primary">
                                    {{ pasajero.nombres }}
                                    {{ pasajero.apellidos }}
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <!-- Pagos de la reserva -->
                  <h5 class="fw-bolder text-muted mt-3">Pagos</h5>
                  <div class="card card-body shadow">
                     <div class="text-end mt-2 mb-4">
                        <button
                           v-if="reserva.estado != 3"
                           @click="getCuentasBancarias"
                           data-bs-toggle="modal"
                           data-bs-target="#agregar_pago"
                           class="btn btn-success btn-rounded btn-sm"
                           :disabled="reserva.saldo <= 0"
                        >
                           <i class="fa fa-plus-circle"></i> Agregar pago
                        </button>
                     </div>
                     <div v-if="reserva.pagos != null" class="table-responsive">
                        <table
                           class="table table-hover table-condensed my_table_2"
                        >
                           <thead>
                              <tr>
                                 <th>Fecha de pago</th>
                                 <th>Medio de pago</th>
                                 <th class="text-end">Valor pago</th>
                                 <th class="text-end">Opciones</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(pago, index_pago) in reserva.pagos"
                                 v-bind:key="index_pago"
                              >
                                 <td class="fw-bolder text-primary">
                                    {{ pago.fecha_pago }}
                                 </td>
                                 <td class="fw-bolder text-primary">
                                    {{ pago.medio.medio }}
                                    <span
                                       v-if="pago.cuenta != null"
                                       class="small text-muted"
                                    >
                                       <br />
                                       {{ pago.cuenta }}
                                    </span>
                                    <span
                                       v-if="pago.cod_bono != null"
                                       class="small text-muted"
                                    >
                                       <br />
                                       {{ pago.cod_bono }}
                                    </span>
                                 </td>
                                 <td class="text-end">
                                    {{ pago.valor | currency }}
                                 </td>
                                 <td class="text-end">
                                    <a
                                       v-if="pago.soporte != null"
                                       :href="pago.soporte"
                                       class="btn btn-info btn-sm btn-rounded me-1"
                                       target="_blank"
                                    >
                                       <i class="fa fa-file"></i>
                                    </a>
                                    <button
                                       v-on:click="pago_sel = pago"
                                       data-bs-toggle="modal"
                                       data-bs-target="#eliminar_pago"
                                       class="btn btn-danger btn-sm btn-rounded"
                                    >
                                       <i class="fa fa-trash"></i>
                                    </button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <div v-else class="p-3">
                        <div class="text-muted">
                           <i class="fa fa-info-circle"></i> No se han
                           registrado pagos para esta reserva.
                        </div>
                     </div>
                  </div>

                  <!--Bonos redimibles -->
                  <div v-if="reserva.bonos.length != 0">
                     <h5 class="fw-bolder text-muted mt-3">Bonos</h5>
                     <div class="card card-body shadow">
                        <div class="table-responsive">
                           <table
                              class="table table-hover table-condensed my_table_2"
                           >
                              <thead>
                                 <tr>
                                    <th>Fecha de registro</th>
                                    <th>Código</th>
                                    <th class="text-end">Total</th>
                                    <th class="text-end">Saldo</th>
                                    <th class="text-center">Estado</th>
                                    <th class="text-end">Opciones</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr
                                    v-for="(bono, indexBono) in reserva.bonos"
                                    v-bind:key="indexBono"
                                 >
                                    <td class="fw-bolder text-primary">
                                       {{ bono.fecha_reg }}
                                    </td>
                                    <td class="fw-bolder text-primary">
                                       {{ bono.cod_bono }}
                                    </td>
                                    <td class="text-end">
                                       {{ bono.valor | currency }}
                                    </td>
                                    <td class="text-end">
                                       {{ bono.saldo | currency }}
                                    </td>
                                    <td class="text-center">
                                       <span
                                          v-if="bono.estado == 1"
                                          class="text-success"
                                          >Activo</span
                                       >
                                       <span
                                          v-if="bono.estado == 0"
                                          class="text-danger"
                                          >Anulado</span
                                       >
                                    </td>
                                    <td class="text-end">
                                       <button
                                          v-if="bono.pagos.length != 0"
                                          v-on:click="bonoSel = bono"
                                          data-bs-toggle="modal"
                                          data-bs-target="#detallePagosBono"
                                          class="btn btn-info btn-sm btn-rounded"
                                       >
                                          <i class="fa fa-list"></i>
                                       </button>
                                       <button
                                          v-on:click="bonoSel = bono"
                                          data-bs-toggle="modal"
                                          data-bs-target="#eliminarBono"
                                          class="btn btn-danger btn-sm btn-rounded"
                                          :disabled="bono.estado == 0"
                                       >
                                          <i class="fa fa-trash"></i>
                                       </button>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                        <div class="mt-2 text-end">
                           <small>Total en Bonos</small>
                           <h5 class="fw-bolder text-success">
                              {{ reserva.totalBonos | currency }}
                           </h5>
                           <small>Total Saldo en Bonos</small>
                           <h5 class="fw-bolder text-success">
                              {{ reserva.totalSaldoBonos | currency }}
                           </h5>
                        </div>
                     </div>
                  </div>

                  <!-- Totales -->
                  <div class="card card-body shadow mt-3">
                     <div class="mt-4 text-end">
                        <small>Total reserva</small>
                        <h5 class="text-info fw-bolder">
                           {{ reserva.valor | currency }}
                        </h5>
                        <small>Descuento</small>
                        <h5 class="text-info fw-bolder">
                           {{ reserva.descuento | currency }}
                           <br />
                           <small v-if="reserva.descuento != 0 && permiso"
                              ><a
                                 v-on:click="delete_descuento()"
                                 class="text-danger"
                                 href="javascript:void(0)"
                              >
                                 <i class="fa fa-trash"></i> Quitar descuento</a
                              ></small
                           >
                        </h5>

                        <small>Valor total</small>
                        <h5 class="text-info fw-bolder">
                           {{ reserva.total | currency }}
                        </h5>
                        <small>Total pagos</small>
                        <h5 class="text-primary fw-bolder">
                           {{ reserva.total_pagos | currency }}
                        </h5>
                        <small>Saldo</small>
                        <h5 class="text-success fw-bolder">
                           {{ reserva.saldo | currency }}
                        </h5>
                     </div>
                  </div>

                  <!-- Notas -->
                  <h5 class="fw-bolder text-muted mt-3">Notas</h5>
                  <div class="card card-body shadow mt-3">
                     <div class="text-end">
                        <button
                           data-bs-toggle="modal"
                           data-bs-target="#nota"
                           class="btn btn-primary btn-sm rounded-pill"
                        >
                           <i class="fa fa-plus-circle"></i> Agregar nota
                        </button>
                     </div>
                     <div v-if="reserva.notas.length != 0">
                        <div
                           v-for="(nota, index_nota) in reserva.notas"
                           v-bind:key="index_nota"
                           class="mb-2"
                        >
                           <div
                              v-if="
                                 (nota.tipo == 2 && permiso) ||
                                 nota.tipo == 1 ||
                                 nota.tipo == 3 ||
                                 nota.tipo == 0
                              "
                           >
                              <small class="text-muted fst-italic"
                                 >{{ nota.fecha_reg }} -
                                 <span v-if="nota.id_usuario != null">
                                    {{ nota.usuario }}</span
                                 >
                                 <span v-if="nota.id_cliente_comprador != null">
                                    Comprador:
                                    {{ nota.cliente_comprador }}</span
                                 >
                                 <strong v-if="nota.tipo == 1">
                                    - Nota para cliente</strong
                                 ></small
                              >

                              <div class="bg-light p-2">
                                 {{ nota.nota }}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- Tareas -->
                  <h5 class="fw-bolder text-muted mt-3">Tareas</h5>
                  <div class="card card-body shadow mt-3">
                     <div class="text-end">
                        <button
                           data-bs-toggle="modal"
                           data-bs-target="#addTarea"
                           class="btn btn-primary btn-sm rounded-pill"
                        >
                           <i class="fa fa-plus-circle"></i> Agregar tarea
                        </button>
                     </div>
                     <div v-if="tasks.length != 0" class="mt-3">
                        <div
                           v-for="(task, index_task) in tasks"
                           :key="index_task"
                           class="card border mb-2"
                        >
                           <div class="card-body py-2">
                              <div
                                 v-if="task.alert === true"
                                 class="text-danger fw-bold py-2 mb-2"
                              >
                                 <i class="fa fa-exclamation-triangle"></i>
                                 Tarea vencida
                              </div>
                              <div class="d-flex justify-content-between">
                                 <div class="me-2">
                                    <h6 class="mb-1 text-primary">
                                       <i
                                          :class="{
                                             'fa fa-circle text-danger':
                                                task.alert,
                                             'fa-regular fa-circle text-muted':
                                                !task.alert &&
                                                !isTaskCompleted(task),
                                             'fa-solid fa-circle-check text-success':
                                                isTaskCompleted(task),
                                          }"
                                       ></i>
                                       {{ task.description }}
                                    </h6>
                                    <small class="text-muted">
                                       Vence:
                                       {{ task.date_format }}
                                    </small>
                                 </div>
                                 <div class="form-check form-switch mt-2 m-0">
                                    <input
                                       class="form-check-input"
                                       type="checkbox"
                                       :id="`task-status-${index_task}`"
                                       :checked="isTaskCompleted(task)"
                                       @change="
                                          updateStatusTask(
                                             task,
                                             $event.target.checked,
                                          )
                                       "
                                    />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div v-else>
                        <div class="alert alert-light mb-0">
                           No hay tareas registradas para esta reserva.
                        </div>
                     </div>
                  </div>
               </div>
               <div v-else>
                  <div class="alert alert-danger">
                     <i class="fa fa-exclamation-circle"></i> No se encontró al
                     reserva que intenta consultar.
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Editar servicio -->
      <div class="modal fade" id="editar_servicio">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Editar servicio</h5>
                  <button
                     id="close_modal"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div v-if="servicio_sel != null">
                     <div v-if="servicio_sel.tipo == 1">
                        <div class="form-group">
                           <label>Servicio</label>
                           <v-select
                              v-model="servicio_sel.servicio"
                              @search="get_actividades"
                              label="servicio"
                              :options="actividades"
                              :clearable="false"
                           ></v-select>
                        </div>
                        <div class="form-group">
                           <label>Adultos</label>
                           <input
                              v-model="servicio_sel.adultos"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div class="form-group">
                           <label>Niños</label>
                           <input
                              v-model="servicio_sel.ninos"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div class="form-group">
                           <label>Infantes</label>
                           <input
                              v-model="servicio_sel.infantes"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div class="form-group">
                           <label>Fecha de actividad</label>
                           <input
                              v-model="servicio_sel.fecha_actividad.sf"
                              class="form-control"
                              type="date"
                           />
                        </div>
                        <div v-if="servicio_sel != null" class="form-group">
                           <label>Horario</label>
                           <v-select
                              v-model="servicio_sel.horario"
                              label="desde"
                              :options="horarios"
                           ></v-select>
                        </div>
                        <div class="text-end">
                           <button
                              v-on:click="update_servicio"
                              class="btn btn-success rounded-pill btn-sm"
                           >
                              <i class="fa fa-save"></i> Guardar
                           </button>
                           <button
                              data-bs-dismiss="modal"
                              class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                           >
                              Cancelar
                           </button>
                        </div>
                     </div>
                     <div
                        v-if="
                           servicio_sel.tipo == 2 ||
                           servicio_sel.tipo == 4 ||
                           servicio_sel.tipo == 5
                        "
                     >
                        <div>
                           <div
                              v-if="servicio_sel.tipo == 4"
                              class="form-group"
                           >
                              <label>Tipo</label>
                              <select
                                 v-model="servicio_sel.tipo_tiquete"
                                 class="form-control"
                              >
                                 <option value="RT">RT</option>
                                 <option value="OW">OW</option>
                              </select>
                           </div>
                           <div class="form-group">
                              <label>Origen</label>
                              <v-select
                                 v-model="servicio_sel.origen"
                                 @input="ciudades = []"
                                 @search="get_ciudades"
                                 label="ciudad_pais"
                                 :options="ciudades"
                                 :clearable="false"
                              ></v-select>
                           </div>
                           <div class="form-group">
                              <label>Destino</label>
                              <v-select
                                 v-model="servicio_sel.destino"
                                 @input="ciudades = []"
                                 @search="get_ciudades"
                                 label="ciudad_pais"
                                 :options="ciudades"
                                 :clearable="false"
                              ></v-select>
                           </div>
                           <div class="form-group">
                              <label>Pasajeros</label>
                              <input
                                 v-model="servicio_sel.num_pasajeros"
                                 class="form-control"
                                 type="number"
                                 min="1"
                              />
                           </div>
                           <div class="form-group">
                              <label>Fecha ida</label>
                              <input
                                 v-model="servicio_sel.fecha_ida.sf"
                                 type="date"
                                 class="form-control"
                              />
                           </div>
                           <div
                              v-if="
                                 servicio_sel.tipo == 2 ||
                                 servicio_sel.tipo == 5 ||
                                 servicio_sel.tipo_tiquete == 'RT'
                              "
                              class="form-group"
                           >
                              <label>Fecha regreso</label>
                              <input
                                 v-model="servicio_sel.fecha_regreso.sf"
                                 :min="servicio_sel.fecha_ida.sf"
                                 type="date"
                                 class="form-control"
                              />
                           </div>
                           <div class="form-group">
                              <label>Proveedor</label>
                              <v-select
                                 v-model="servicio_sel.proveedor"
                                 @input="proveedores = []"
                                 @search="get_proveedores"
                                 label="proveedor"
                                 :options="proveedores"
                                 :clearable="false"
                              ></v-select>
                           </div>
                           <div class="form-group">
                              <label>Precio neto</label>
                              <money
                                 v-model="servicio_sel.valor_neto"
                                 class="form-control text-end"
                                 v-bind="money"
                                 required
                              >
                              </money>
                           </div>
                           <div class="form-group">
                              <label>Precio venta</label>
                              <money
                                 v-model="servicio_sel.valor_venta"
                                 class="form-control text-end"
                                 v-bind="money"
                                 required
                              >
                              </money>
                           </div>
                           <div class="text-end">
                              <button
                                 v-on:click="update_servicio()"
                                 :disabled="
                                    servicio_sel.num_pasajeros <= 0 ||
                                    servicio_sel.origen == null ||
                                    servicio_sel.destino == null ||
                                    servicio_sel.fecha_ida == null ||
                                    ((servicio_sel.tipo_tiquete == 'RT' ||
                                       servicio_sel.tipo == 2 ||
                                       servicio_sel == 5) &&
                                       servicio_sel.fecha_regreso == null) ||
                                    servicio_sel.proveedor == null
                                 "
                                 class="btn btn-success rounded-pill btn-sm"
                              >
                                 <i class="fa fa-save"></i> Guardar
                              </button>
                              <button
                                 data-bs-dismiss="modal"
                                 class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                              >
                                 Cancelar
                              </button>
                           </div>
                        </div>
                     </div>
                     <div v-if="servicio_sel.tipo == 3">
                        <div>
                           <div class="form-group">
                              <label>Hotel</label>
                              <v-select
                                 v-model="servicio_sel.servicio"
                                 @search="get_hoteles"
                                 label="servicio"
                                 :options="hoteles"
                                 :clearable="false"
                              ></v-select>
                           </div>
                           <div class="form-group">
                              <label>Pasajeros</label>
                              <input
                                 v-model="servicio_sel.num_pasajeros"
                                 class="form-control"
                                 type="number"
                                 min="1"
                              />
                           </div>
                           <div class="form-group">
                              <label>Fecha ida</label>
                              <input
                                 v-model="servicio_sel.fecha_ida.sf"
                                 type="date"
                                 class="form-control"
                              />
                           </div>
                           <div class="form-group">
                              <label>Fecha regreso</label>
                              <input
                                 v-model="servicio_sel.fecha_regreso.sf"
                                 type="date"
                                 :min="servicio_sel.fecha_ida.sf"
                                 class="form-control"
                              />
                           </div>

                           <div class="form-group">
                              <label>Precio neto</label>
                              <money
                                 v-model="servicio_sel.valor_neto"
                                 class="form-control text-end"
                                 v-bind="money"
                                 required
                              >
                              </money>
                           </div>
                           <div class="form-group">
                              <label>Precio venta</label>
                              <money
                                 v-model="servicio_sel.valor_venta"
                                 class="form-control text-end"
                                 v-bind="money"
                                 required
                              >
                              </money>
                           </div>
                           <div class="text-end">
                              <button
                                 v-on:click="update_servicio()"
                                 :disabled="
                                    servicio_sel.servicio == null ||
                                    servicio_sel.num_pasajeros <= 0 ||
                                    servicio_sel.fecha_ida == null ||
                                    servicio_sel.fecha_regreso == null
                                 "
                                 class="btn btn-success rounded-pill btn-sm"
                              >
                                 <i class="fa fa-save"></i> Guardar
                              </button>
                              <button
                                 data-bs-dismiss="modal"
                                 class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                              >
                                 Cancelar
                              </button>
                           </div>
                        </div>
                     </div>
                     <div v-if="servicio_sel.tipo == 6">
                        <div class="form-group">
                           <label>Descripción</label>
                           <textarea
                              v-model="servicio_sel.descripcion"
                              class="form-control"
                           />
                        </div>
                        <div class="form-group">
                           <label>Incluye</label>
                           <editor
                              v-model="servicio_sel.incluye"
                              :api-key="editor.api_key"
                              :init="editor.init"
                           />
                        </div>
                        <div class="form-group">
                           <label>Adultos</label>
                           <input
                              v-model="servicio_sel.adultos"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div class="form-group">
                           <label>Niños</label>
                           <input
                              v-model="servicio_sel.ninos"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div class="form-group">
                           <label>Infantes</label>
                           <input
                              v-model="servicio_sel.infantes"
                              class="form-control"
                              type="number"
                           />
                        </div>
                        <div
                           v-if="servicio_sel.fecha_actividad != null"
                           class="form-group"
                        >
                           <label>Fecha de actividad</label>
                           <input
                              v-model="servicio_sel.fecha_actividad.sf"
                              class="form-control"
                              type="date"
                           />
                        </div>
                        <div
                           v-if="session?.usuario.usuario.permisos?.VERNETOS"
                           class="form-group"
                        >
                           <label>Precio neto</label>
                           <money
                              v-model="servicio_sel.valor_neto"
                              class="form-control text-end"
                              v-bind="money"
                              required
                           ></money>
                        </div>
                        <div class="form-group">
                           <label>Precio venta</label>
                           <money
                              v-model="servicio_sel.valor_venta"
                              class="form-control text-end"
                              v-bind="money"
                              required
                           ></money>
                        </div>
                        <div class="text-end">
                           <button
                              v-on:click="update_servicio"
                              class="btn btn-success rounded-pill btn-sm"
                           >
                              <i class="fa fa-save"></i> Guardar
                           </button>
                           <button
                              data-bs-dismiss="modal"
                              class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                           >
                              Cancelar
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Eliminar servicio -->
      <div class="modal fade" id="eliminar_servicio">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-danger">
                  <h5 class="modal-title fw-bolder">Eliminar servicio</h5>
                  <button
                     id="close_modal_eliminar"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div v-if="servicio_sel != null">
                     <span class="text-danger">
                        ¿Desea eliminar el servicio de esta reserva?
                     </span>
                     <div class="text-end">
                        <button
                           v-on:click="delete_servicio"
                           class="btn btn-danger rounded-pill btn-sm"
                        >
                           <i class="fa fa-trash"></i> Sí
                        </button>
                        <button
                           data-bs-dismiss="modal"
                           class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                        >
                           No
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Agregar pago -->
      <div class="modal fade" id="agregar_pago">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Agregar pago</h5>
                  <button
                     id="close_modal_pago"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="form-group">
                     <label>Fecha de pago</label>
                     <input
                        v-model="nuevo_pago.fecha"
                        class="form-control"
                        type="date"
                     />
                  </div>
                  <div class="form-group">
                     <label>Valor del pago</label>
                     <money
                        v-model="nuevo_pago.valor"
                        class="form-control text-end"
                        v-bind="money"
                        required
                     ></money>
                  </div>
                  <div class="form-group">
                     <label>Medio de pago</label>
                     <select
                        v-model="nuevo_pago.medio"
                        @change="getCuentasBancarias"
                        class="form-control"
                     >
                        <option value="0">Pasarela de pago</option>
                        <option value="1">Consignación o transferencia</option>
                        <option value="2">Efectivo</option>
                        <option value="3">Tarjetas de crédito</option>
                        <option value="4">Pago en destino</option>
                        <option value="5">Bono</option>
                     </select>
                  </div>

                  <div v-if="nuevo_pago.medio == 1" class="form-group">
                     <label>Cuenta bancaria</label>
                     <select v-model="nuevo_pago.cuenta" class="form-control">
                        <option value="null">
                           Selecciona la cuenta bancaria
                        </option>
                        <option
                           v-for="(cuenta, indexCuenta) in cuentas"
                           :key="indexCuenta"
                           :value="cuenta.id_cuenta"
                        >
                           {{ cuenta.cuenta }}
                        </option>
                     </select>
                  </div>

                  <div
                     v-if="
                        nuevo_pago.medio == 0 ||
                        nuevo_pago.medio == 1 ||
                        nuevo_pago.medio == 3
                     "
                     class="form-group"
                  >
                     <label>Agregar archivo soporte</label>
                     <input
                        ref="input_file_soport"
                        @change="handle_images"
                        type="file"
                        class="form-control"
                        accept="image/*,application/pdf"
                     />
                  </div>

                  <div v-if="nuevo_pago.medio == 5" class="form-group">
                     <label>Código del bono</label>
                     <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1"
                           >BR-</span
                        >
                        <input
                           v-model="nuevo_pago.bono"
                           type="text"
                           class="form-control"
                           placeholder="Código del bono"
                           aria-describedby="basic-addon1"
                        />
                     </div>
                  </div>

                  <div class="text-end">
                     <button
                        v-on:click="set_pago"
                        class="btn btn-success rounded-pill btn-sm"
                     >
                        <i class="fa fa-save"></i> Guardar
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        Cancelar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Eliminar pago -->
      <div class="modal fade" id="eliminar_pago">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-danger">
                  <h5 class="modal-title fw-bolder">Eliminar pago</h5>
                  <button
                     id="close_modal_eliminar_pago"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="pago_sel != null" class="modal-body">
                  <div class="text-danger">
                     <div class="mb-3">
                        <i class="fa fa-question-circle"></i> ¿Desea eliminar
                        este pago?
                     </div>
                     <div>
                        <ul>
                           <li>
                              Fecha de pago:
                              <strong>{{ pago_sel.fecha_pago }}</strong>
                           </li>
                           <li>
                              Medio: <strong>{{ pago_sel.medio.medio }}</strong>
                           </li>
                           <li>
                              Valor:
                              <strong>{{ pago_sel.valor | currency }}</strong>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        v-on:click="delete_pago"
                        class="btn btn-danger rounded-pill btn-sm"
                     >
                        <i class="fa fa-trash"></i> Sí
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        No
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Aprobar reserva -->
      <div class="modal fade" id="aprobar_reserva">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-primary">
                  <h5 class="modal-title fw-bolder">Aprobar reserva</h5>
                  <button
                     id="close_modal_aprobar"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="text-primary">
                     <div class="mb-3">
                        <i class="fa fa-question-circle"></i> ¿Desea aprobar
                        esta reserva?
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        v-on:click="aprobar_reserva"
                        class="btn btn-success rounded-pill btn-sm"
                     >
                        <i class="fa fa-check-circle"></i> Sí
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        No
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Enviar email -->
      <div class="modal fade" id="enviar_email">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-primary">
                  <h5 class="modal-title fw-bolder">Enviar email</h5>
                  <button
                     id="close_modal_enviar"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <form v-on:submit.prevent="enviar_email">
                     <div v-if="reserva != null" class="form-group">
                        <label>Email</label>
                        <input
                           v-model="reserva.cliente.email"
                           type="email"
                           class="form-control"
                           required
                        />
                     </div>
                     <div class="text-end">
                        <button
                           type="submit"
                           class="btn btn-success rounded-pill btn-sm"
                        >
                           <i class="fa-solid fa-paper-plane"></i> Enviar
                        </button>
                        <button
                           data-bs-dismiss="modal"
                           class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                        >
                           Cancelar
                        </button>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
      <!-- Vouchers -->
      <div class="modal fade" id="vouchers">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Vouchers</h5>
                  <button
                     id="close_modal"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="card card-body border shadow">
                     <div class="form-group">
                        <label>Subir archivo</label>
                        <input
                           ref="input_file"
                           @change="handle_images"
                           type="file"
                           class="form-control"
                           accept="image/*,application/pdf"
                        />
                     </div>
                     <div class="form-group">
                        <label>Título o descripción</label>
                        <input
                           v-model="titulo_archivo"
                           type="text"
                           class="form-control"
                        />
                     </div>
                     <div class="text-end">
                        <button
                           @click="upload_voucher"
                           :disabled="!hay_archivo"
                           class="btn btn-primary btn-sm rounded-pill"
                        >
                           <i class="fa fa-upload"></i> Guardar
                        </button>
                     </div>
                  </div>

                  <div v-if="index_servicio_sel != null" class="mt-4">
                     <div
                        v-if="
                           reserva.servicios[index_servicio_sel].vouchers
                              .length != 0
                        "
                     >
                        <div
                           v-for="(voucher, index_voucher) in reserva.servicios[
                              index_servicio_sel
                           ].vouchers"
                           v-bind:key="index_voucher"
                           class="card card-body shadow mb-2"
                        >
                           <div>
                              <a
                                 :href="voucher.url"
                                 target="_blank"
                                 class="fw-bold"
                              >
                                 <i class="fa fa-file"></i> {{ voucher.titulo }}
                              </a>
                              <div class="text-end">
                                 <small>
                                    <a
                                       @click="
                                          delete_voucher(voucher.id_voucher)
                                       "
                                       href="javascript:void(0)"
                                       class="text-danger"
                                    >
                                       <i class="fa fa-trash"></i> Eliminar
                                    </a>
                                 </small>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div v-else>
                        <hr />
                        <span class="text-muted">
                           <i class="fa fa-info-circle"></i> No se han agregado
                           vouchers para este servicio.
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Generar Vouchers -->
      <div class="modal fade" id="generarVouchers">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Generar vouchers</h5>
                  <button
                     id="close_modal"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="text-muted">
                     <i class="fa fa-info-circle"></i> Seleccione lo servicios
                     para los cuales desea generar vouchers.
                  </div>
                  <div class="form-group p-4">
                     <div
                        v-for="(servicio, index) in reserva?.servicios"
                        :key="index"
                        class="form-check"
                     >
                        <input
                           v-model="serviciosVouchers"
                           class="form-check-input"
                           type="checkbox"
                           :name="'servicio'"
                           :id="'servicio' + servicio.id_servicio_reserva"
                           :value="servicio.id_servicio_reserva"
                        />
                        <label
                           class="form-check-label"
                           :for="'servicio' + servicio.id_servicio_reserva"
                        >
                           {{ servicio.servicio.servicio }}
                        </label>
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        @click="generarVouchers"
                        data-bs-dismiss="modal"
                        :disabled="serviciosVouchers.length == 0"
                        class="btn btn-primary btn-sm rounded-pill"
                     >
                        <i class="fa fa-file-contract"></i> Generar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Nota -->
      <div class="modal fade" id="nota">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Nueva nota</h5>
                  <button
                     id="close_modal"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="form-group">
                     <label>Tipo</label>
                     <select v-model="nueva_nota.tipo" class="form-control">
                        <option value="2">Admin</option>
                        <option value="0">Agentes y administrativos</option>
                        <option value="1">Todos</option>
                     </select>
                  </div>
                  <div class="form-group">
                     <label>Nota</label>
                     <textarea
                        v-model="nueva_nota.nota"
                        class="form-control"
                        rows="4"
                     ></textarea>
                  </div>
                  <div class="text-end">
                     <button
                        @click="set_nota"
                        :disabled="
                           nueva_nota.nota == null ||
                           nueva_nota.nota.trim().length == 0
                        "
                        class="btn btn-primary btn-sm rounded-pill"
                     >
                        <i class="fa fa-save"></i> Guardar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Agregar tarea -->
      <div class="modal fade" id="addTarea">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Nueva tarea</h5>
                  <button
                     id="close_modal_task"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="form-group">
                     <label>Descripción</label>
                     <textarea
                        v-model="nueva_tarea.description"
                        class="form-control"
                        rows="4"
                     ></textarea>
                  </div>
                  <div class="form-group">
                     <label>Fecha de vencimiento</label>
                     <input
                        v-model="nueva_tarea.due_date"
                        class="form-control"
                        type="date"
                     />
                  </div>
                  <div class="text-end">
                     <button
                        @click="setTask"
                        :disabled="
                           nueva_tarea.description == null ||
                           nueva_tarea.description.trim().length == 0 ||
                           nueva_tarea.due_date == null
                        "
                        class="btn btn-primary btn-sm rounded-pill"
                     >
                        <i class="fa fa-save"></i> Guardar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Pasajeros -->
      <div class="modal fade" id="pasajeros">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Pasajeros</h5>
                  <button
                     id="close_modal_pasajeros"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="reserva != null" class="modal-body">
                  <div v-if="reserva.pasajeros.length != 0">
                     <div
                        v-for="(pasajero, index_pasajero) in reserva.pasajeros"
                        v-bind:key="index_pasajero"
                        class="card card-body border shadow mb-3"
                     >
                        <span class="text-muted fw-bold"
                           >Pasajero {{ index_pasajero + 1 }}</span
                        >
                        <div class="row">
                           <div class="col-lg-6 form-group">
                              <label>Nombres</label>
                              <input
                                 v-model="pasajero.nombres"
                                 type="text"
                                 class="form-control"
                              />
                           </div>
                           <div class="col-lg-6 form-group">
                              <label>Apellidos</label>
                              <input
                                 v-model="pasajero.apellidos"
                                 type="text"
                                 class="form-control"
                              />
                           </div>
                        </div>
                        <div class="text-end">
                           <small>
                              <a
                                 @click="eliminar_pasajero(index_pasajero)"
                                 href="javascript:void(0)"
                                 class="text-danger"
                              >
                                 <i class="fa fa-trash"></i> Eliminar
                              </a>
                           </small>
                        </div>
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        v-if="reserva.estado != 3"
                        @click="set_pasajero"
                        class="btn btn-primary btn-sm rounded-pill"
                     >
                        <i class="fa fa-plus-circle"></i> Agregar pasajero
                     </button>
                  </div>
                  <hr />
                  <div class="text-end mt-4">
                     <button
                        v-if="reserva.estado != 3"
                        @click="update_pasajeros"
                        class="btn btn-success btn-sm rounded-pill"
                     >
                        <i class="fa fa-save"></i> Guardar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Anular -->
      <div class="modal fade" id="anular">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-primary">
                  <h5 class="modal-title fw-bolder">Anular reserva</h5>
                  <button
                     id="close_modal_anular"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="text-danger">
                     <i class="fa fa-info-question"></i> ¿Desea anular esta
                     reserva?
                  </div>
                  <div class="text-end">
                     <button
                        v-on:click="anular_reserva"
                        class="btn btn-danger rounded-pill btn-sm"
                     >
                        <i class="fa fa-trash"></i> Si, anular
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        Cancelar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Crear bono -->
      <div v-if="reserva != null" class="modal fade" id="crearBono">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Crear bono</h5>
                  <button
                     id="close_modal_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="form-group ps-4">
                     <div class="form-check">
                        <input
                           v-model="nuevoBono.tipo"
                           @click="nuevoBono.valor = valorMaxBono"
                           class="form-check-input"
                           type="radio"
                           name="bonoValorTotal"
                           id="bonoValorTotal"
                           value="0"
                           checked
                        />
                        <label class="form-check-label" for="bonoValorTotal">
                           Valor total o saldo disponible
                        </label>
                     </div>
                     <div class="form-check">
                        <input
                           v-model="nuevoBono.tipo"
                           class="form-check-input"
                           type="radio"
                           name="bonoValorParcial"
                           id="bonoValorParcial"
                           value="1"
                        />
                        <label class="form-check-label" for="bonoValorParcial">
                           Valor parcial
                        </label>
                     </div>
                  </div>

                  <div class="form-group">
                     <label>Valor del bono</label>
                     <money
                        v-model="nuevoBono.valor"
                        class="form-control text-end"
                        v-bind="money"
                        :max="reserva.total"
                        required
                        :disabled="nuevoBono.tipo == 0"
                     ></money>
                  </div>

                  <div class="text-end">
                     <button
                        v-on:click="setBono"
                        class="btn btn-success rounded-pill btn-sm"
                     >
                        <i class="fa fa-save"></i> Guardar
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        Cancelar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Eliminar bono -->
      <div class="modal fade" id="eliminarBono">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-danger">
                  <h5 class="modal-title fw-bolder">Anular bono</h5>
                  <button
                     id="close_modal_eliminar_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="bonoSel != null" class="modal-body">
                  <div class="text-danger">
                     <div class="mb-3">
                        <i class="fa fa-question-circle"></i> ¿Desea anular este
                        bono? El saldo disponible no podrá ser utilizado.
                     </div>
                     <div>
                        <ul>
                           <li>
                              Fecha de registro:
                              <strong>{{ bonoSel.fecha_reg }}</strong>
                           </li>
                           <li>
                              Valor:
                              <strong>{{ bonoSel.valor | currency }}</strong>
                           </li>
                           <li>
                              Saldo:
                              <strong>{{ bonoSel.saldo | currency }}</strong>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        v-on:click="deleteBono"
                        class="btn btn-danger rounded-pill btn-sm"
                     >
                        <i class="fa fa-trash"></i> Sí
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        No
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Pagos bono -->
      <div class="modal fade" id="detallePagosBono">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Pagos con bono</h5>
                  <button
                     id="close_modal_pagos_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="bonoSel != null" class="modal-body">
                  <table class="table table-hover table-condensed my_table_2">
                     <thead>
                        <tr>
                           <th>Fecha de pago</th>
                           <th class="text-center">Reserva</th>
                           <th class="text-end">Valor</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr
                           v-for="(pago, index_pago) in bonoSel.pagos"
                           v-bind:key="index_pago"
                        >
                           <td class="fw-bolder text-primary">
                              {{ pago.fecha_pago }}
                           </td>
                           <td class="fw-bolder text-primary">
                              <router-link
                                 :to="'/reserva/' + pago.id_reserva"
                                 target="_blank"
                              >
                                 {{ pago.cod_reserva }}
                              </router-link>
                           </td>
                           <td class="text-end">
                              {{ pago.valor | currency }}
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
      <!-- Pagos proveedor -->
      <div class="modal fade" id="pagosProveedor">
         <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Pagos a proveedor</h5>
                  <button
                     id="close_modal_pagos_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="index_servicio_sel != null" class="modal-body">
                  <small>Servicio</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].servicio.servicio
                     }}
                  </h5>
                  <small>Proveedor</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].proveedor
                           ?.proveedor
                     }}
                  </h5>
                  <div class="text-end mt-2 mb-2">
                     <button
                        @click="
                           (nuevo_pago_proveedor.valor =
                              reserva.servicios[index_servicio_sel].valor_neto -
                              reserva.servicios[index_servicio_sel]
                                 .total_pagos_proveedor),
                              getCuentasBancarias(false)
                        "
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                        data-bs-target="#agregarPagoProveedor"
                        class="btn btn-success btn-sm"
                     >
                        <i class="fa fa-plus-circle"></i> Agregar pago
                     </button>
                  </div>
                  <div
                     v-if="
                        reserva.servicios[index_servicio_sel].pagos_proveedor
                           .length != 0
                     "
                     class="mt-3"
                  >
                     <div class="table-responsive">
                        <table
                           class="table table-bordered table-condensed table-hover my_table_2"
                        >
                           <thead>
                              <tr>
                                 <th class="text-center">#</th>
                                 <th>Fecha de registro</th>
                                 <th>Fecha de pago</th>
                                 <th>Usuario</th>
                                 <th>Medio - Cuenta</th>
                                 <th>Valor</th>
                                 <th class="text-center">Opciones</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(pago, indexPago) in reserva.servicios[
                                    index_servicio_sel
                                 ].pagos_proveedor"
                                 :key="indexPago"
                              >
                                 <td class="text-center">
                                    {{ indexPago + 1 }}.
                                 </td>
                                 <td>{{ pago.fecha_reg }}</td>
                                 <td>{{ pago.fecha_pago }}</td>
                                 <td>{{ pago.usuario }}</td>
                                 <td>
                                    <span v-if="pago.medio == 1"
                                       >Consignación transferencia</span
                                    >
                                    <span v-if="pago.medio == 2">Efectivo</span>
                                    <span v-if="pago.id_cuenta != null">
                                       - {{ pago.cuenta }}
                                    </span>
                                 </td>
                                 <td class="text-end">
                                    {{ pago.valor | currency }}
                                 </td>
                                 <td class="text-center">
                                    <button
                                       v-if="permiso"
                                       @click="
                                          deletePagoProveedor(
                                             pago.id_pago_proveedor,
                                          )
                                       "
                                       class="btn btn-outline-danger btn-rounded btn-xs ms-1"
                                    >
                                       <i class="fa-solid fa-trash"></i>
                                    </button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        <div class="text-end mt-4">
                           <small>Total pagos</small>
                           <h6 class="text-primary fw-bolder">
                              {{
                                 reserva.servicios[index_servicio_sel]
                                    .total_pagos_proveedor | currency
                              }}
                           </h6>
                           <small>Saldo pendiente</small>
                           <h6 class="text-primary fw-bolder">
                              {{
                                 (reserva.servicios[index_servicio_sel]
                                    .valor_neto -
                                    reserva.servicios[index_servicio_sel]
                                       .total_pagos_proveedor)
                                    | currency
                              }}
                           </h6>
                        </div>
                     </div>
                  </div>
                  <div v-else class="mt-4">
                     <span class="text-muted">
                        <i class="fa fa-info-circle"></i> No se han agregado
                        pagos al proveedor.
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Agregar pago proveedor -->
      <div class="modal fade" id="agregarPagoProveedor">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Agregar pago</h5>
                  <button
                     id="close_modal_pagos_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                     data-bs-toggle="modal"
                     data-bs-target="#pagosProveedor"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="index_servicio_sel != null" class="modal-body">
                  <small>Servicio</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].servicio.servicio
                     }}
                  </h5>
                  <small>Proveedor</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].proveedor
                           .proveedor
                     }}
                  </h5>
                  <div class="mt-3">
                     <div class="form-group">
                        <label>Fecha de pago</label>
                        <input
                           v-model="nuevo_pago_proveedor.fecha"
                           class="form-control"
                           type="date"
                        />
                     </div>
                     <div class="form-group">
                        <label>Valor del pago</label>
                        <money
                           v-model="nuevo_pago_proveedor.valor"
                           class="form-control text-end"
                           v-bind="money"
                           required
                        ></money>
                     </div>
                     <div class="form-group">
                        <label>Medio de pago</label>
                        <select
                           v-model="nuevo_pago_proveedor.medio"
                           @change="getCuentasBancarias(false)"
                           class="form-control"
                        >
                           <option value="1">
                              Consignación o transferencia
                           </option>
                           <option value="2">Efectivo</option>
                        </select>
                     </div>

                     <div
                        v-if="nuevo_pago_proveedor.medio == 1"
                        class="form-group"
                     >
                        <label>Cuenta bancaria</label>
                        <select
                           v-model="nuevo_pago_proveedor.cuenta"
                           class="form-control"
                        >
                           <option value="null">
                              Selecciona la cuenta bancaria
                           </option>
                           <option
                              v-for="(cuenta, indexCuenta) in cuentas"
                              :key="indexCuenta"
                              :value="cuenta.id_cuenta"
                           >
                              {{ cuenta.cuenta }}
                           </option>
                        </select>
                     </div>

                     <div
                        v-if="
                           nuevo_pago_proveedor.medio == 0 ||
                           nuevo_pago_proveedor.medio == 1 ||
                           nuevo_pago_proveedor.medio == 3
                        "
                        class="form-group"
                     >
                        <label>Agregar archivo soporte</label>
                        <input
                           ref="input_file_soport"
                           @change="handle_images"
                           type="file"
                           class="form-control"
                           accept="image/*,application/pdf"
                        />
                     </div>

                     <div class="text-end">
                        <button
                           v-on:click="set_pago_proveedor"
                           class="btn btn-success rounded-pill btn-sm"
                        >
                           <i class="fa fa-save"></i> Guardar
                        </button>
                        <button
                           data-bs-dismiss="modal"
                           class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                           data-bs-toggle="modal"
                           data-bs-target="#pagosProveedor"
                        >
                           Cancelar
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Recaudos -->
      <div class="modal fade" id="recaudos">
         <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Recaudos</h5>
                  <button type="button" class="close" data-bs-dismiss="modal">
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="index_servicio_sel != null" class="modal-body">
                  <small>Servicio</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].servicio.servicio
                     }}
                  </h5>
                  <div class="text-end mt-2 mb-2">
                     <button
                        @click="
                           (nuevo_pago_proveedor.valor =
                              reserva.servicios[index_servicio_sel].valor_neto -
                              reserva.servicios[index_servicio_sel]
                                 .total_pagos_proveedor),
                              getCuentasBancarias(false)
                        "
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                        data-bs-target="#agregarRecaudo"
                        class="btn btn-success btn-sm"
                     >
                        <i class="fa fa-plus-circle"></i> Agregar recaudo
                     </button>
                  </div>
                  <div
                     v-if="
                        reserva.servicios[index_servicio_sel].recaudos.length !=
                        0
                     "
                     class="mt-3"
                  >
                     <div class="table-responsive">
                        <table
                           class="table table-bordered table-condensed table-hover my_table_2"
                        >
                           <thead>
                              <tr>
                                 <th class="text-center">#</th>
                                 <th>Fecha de registro</th>
                                 <th>Descripción</th>
                                 <th>Usuario</th>
                                 <th>Cuenta</th>
                                 <th>Valor</th>
                                 <th class="text-center">Opciones</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(pago, indexPago) in reserva.servicios[
                                    index_servicio_sel
                                 ].recaudos"
                                 :key="indexPago"
                              >
                                 <td class="text-center">
                                    {{ indexPago + 1 }}.
                                 </td>
                                 <td>{{ pago.fecha_reg }}</td>
                                 <td>{{ pago.descripcion }}</td>
                                 <td>{{ pago.usuario }}</td>
                                 <td>
                                    <span v-if="pago.medio == 1"
                                       >Consignación transferencia</span
                                    >
                                    <span v-if="pago.medio == 2">Efectivo</span>
                                    <span> {{ pago.cuenta }} </span>
                                 </td>
                                 <td class="text-end">
                                    {{ pago.valor | currency }}
                                 </td>
                                 <td class="text-center">
                                    <button
                                       v-if="permiso"
                                       @click="deleteRecaudo(pago.id_recaudo)"
                                       class="btn btn-outline-danger btn-rounded btn-xs ms-1"
                                    >
                                       <i class="fa-solid fa-trash"></i>
                                    </button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        <div class="text-end mt-4">
                           <small>Total recaudos</small>
                           <h6 class="text-primary fw-bolder">
                              {{
                                 reserva.servicios[index_servicio_sel]
                                    .total_recaudos | currency
                              }}
                           </h6>
                        </div>
                     </div>
                  </div>
                  <div v-else class="mt-4">
                     <span class="text-muted">
                        <i class="fa fa-info-circle"></i> No se han agregado
                        recaudos.
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- Agregar recaudo -->
      <div class="modal fade" id="agregarRecaudo">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Agregar recaudo</h5>
                  <button
                     id="close_modal_pagos_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                     data-bs-toggle="modal"
                     data-bs-target="#recaudos"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="index_servicio_sel != null" class="modal-body">
                  <small>Servicio</small>
                  <h5 class="fw-bold text-primary">
                     {{
                        reserva.servicios[index_servicio_sel].servicio.servicio
                     }}
                  </h5>
                  <div class="mt-3">
                     <div class="form-group">
                        <label>Descripción</label>
                        <input
                           v-model="nuevo_recaudo.descripcion"
                           class="form-control"
                           type="text"
                        />
                     </div>
                     <div class="form-group">
                        <label>Valor</label>
                        <money
                           v-model="nuevo_recaudo.valor"
                           class="form-control text-end"
                           v-bind="money"
                           required
                        ></money>
                     </div>
                     <div class="form-group">
                        <label>Cuenta bancaria</label>
                        <select
                           v-model="nuevo_recaudo.cuenta"
                           class="form-control"
                        >
                           <option value="null">
                              Selecciona la cuenta bancaria
                           </option>
                           <option
                              v-for="(cuenta, indexCuenta) in cuentas"
                              :key="indexCuenta"
                              :value="cuenta.id_cuenta"
                           >
                              {{ cuenta.cuenta }}
                           </option>
                        </select>
                     </div>
                     <div class="text-end">
                        <button
                           v-on:click="setRecaudo"
                           class="btn btn-success rounded-pill btn-sm"
                        >
                           <i class="fa fa-save"></i> Guardar
                        </button>
                        <button
                           data-bs-dismiss="modal"
                           class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                           data-bs-toggle="modal"
                           data-bs-target="#recaudos"
                        >
                           Cancelar
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import Editor from "@tinymce/tinymce-vue";
export default {
   name: "Reserva",
   metaInfo: {
      title: "Reserva - Backoffice",
   },
   components: {
      editor: Editor,
   },
   data() {
      return {
         editor: {
            api_key: this.$editor_api_key,
            init: {
               height: 200,
               menubar: false,
               toolbar: "undo redo  | bold italic  |  bullist numlist  | ",
               plugins: "lists advlist",
            },
         },
         loading: true,
         base_url: this.$base_url,
         id_reserva: null,
         reserva: null,
         servicio_sel: null,
         actividades: [],
         nuevo_pago: {
            medio: 1,
            cuenta: null,
            fecha: new Date().toISOString().slice(0, 10),
            valor: 0,
            bono: null,
         },
         money: {
            decimal: ",",
            thousands: ".",
            prefix: "$ ",
            suffix: "",
            precision: 0,
            masked: false,
         },
         pago_sel: null,
         horarios: [],
         email: null,
         proveedores: [],
         ciudades: [],
         hoteles: [],
         index_servicio_sel: null,
         file: [],
         hay_archivo: false,
         files: [],
         titulo_archivo: null,
         permiso: false,
         permisoRevision: false,
         nueva_nota: {
            tipo: 0,
            nota: null,
         },
         nueva_tarea: {
            description: null,
            due_date: new Date().toISOString().slice(0, 10),
         },
         cuentas: [],
         nuevoBono: {
            tipo: "0",
            valor: 0,
         },
         bonoSel: null,
         valorMaxBono: 0,
         nuevo_pago_proveedor: {
            medio: 1,
            cuenta: null,
            fecha: new Date().toISOString().slice(0, 10),
            valor: 0,
         },
         nuevo_recaudo: {
            descripcion: null,
            cuenta: null,
            valor: 0,
         },
         serviciosVouchers: [],
         tasks: [],
      };
   },
   props: {
      session: Object,
   },
   created: function () {
      this.id_reserva = this.$route.params.id_reserva;
      this.get_reserva();
      this.permiso = this.session.usuario.usuario.permisos.GRESERVAS;
      this.permisoRevision =
         this.session.usuario.usuario.permisos.REVISIONRESERVAS;
   },
   methods: {
      get_reserva: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {},
         };
         axios
            .get(vm.$base_url + "reservas/reserva/" + this.id_reserva, config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.reserva = response.data.data;
                  vm.getTasks();
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            });
      },
      get_actividades: function (search = null) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
            },
         };
         axios
            .get(vm.$base_url + "servicios/actividades_list", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.actividades = response.data.data.actividades;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Actividades",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Actividades",
                  text: error,
               });
               vm.loading = false;
            });
      },
      update_servicio: function () {
         const vm = this;
         var valida = true;
         var servicio = null;
         switch (Number(this.servicio_sel.tipo)) {
            case 1:
               if (this.servicio_sel.servicio == null) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Editar reserva",
                     text: "Seleccione una actividad.",
                  });
                  valida = false;
               }
               if (this.servicio_sel.num_pasajeros <= 0) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Editar reserva",
                     text: "Indique la cantidad de pasajeros",
                  });
                  valida = false;
               }
               if (!valida) {
                  return false;
               }
               var id_horario = null;
               if (this.servicio_sel.horario != null) {
                  id_horario = this.servicio_sel.horario.id_horario;
               }

               servicio = {
                  tipo: 1,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  id_servicio: this.servicio_sel.servicio.id_servicio,
                  adultos: this.servicio_sel.adultos,
                  ninos: this.servicio_sel.ninos,
                  infantes: this.servicio_sel.infantes,
                  fecha_actividad: this.servicio_sel.fecha_actividad.sf,
                  id_horario: id_horario,
               };
               break;

            case 2:
               if (this.servicio_sel.num_pasajeros <= 0) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Indique la cantidad de pasajeros",
                  });
                  return false;
               }
               if (this.servicio_sel.origen == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de origen",
                  });
                  return false;
               }
               if (this.servicio_sel.destino == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de destino",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_ida == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de salida",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_regreso == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de regreso",
                  });
                  return false;
               }
               if (this.servicio_sel.proveedor == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione el proveedor del servicio",
                  });
                  return false;
               }
               servicio = {
                  tipo: 2,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  num_pasajeros: this.servicio_sel.num_pasajeros,
                  origen: this.servicio_sel.origen.id_ciudad,
                  destino: this.servicio_sel.destino.id_ciudad,
                  fecha_ida: this.servicio_sel.fecha_ida.sf,
                  fecha_regreso: this.servicio_sel.fecha_regreso.sf,
                  id_proveedor: this.servicio_sel.proveedor.id_proveedor,
                  valor_neto: this.servicio_sel.valor_neto,
                  valor_venta: this.servicio_sel.valor_venta,
               };
               break;
            case 3:
               if (this.servicio_sel.servicio == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Selecciona el hotel.",
                  });
                  return false;
               }
               if (this.servicio_sel.num_pasajeros <= 0) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Indique la cantidad de pasajeros",
                  });
                  return false;
               }

               if (this.servicio_sel.fecha_ida == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de salida",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_regreso == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de regreso",
                  });
                  return false;
               }

               servicio = {
                  tipo: 3,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  id_servicio: this.servicio_sel.servicio.id_servicio,
                  num_pasajeros: this.servicio_sel.num_pasajeros,
                  fecha_ida: this.servicio_sel.fecha_ida.sf,
                  fecha_regreso: this.servicio_sel.fecha_regreso.sf,
                  valor_neto: this.servicio_sel.valor_neto,
                  valor_venta: this.servicio_sel.valor_venta,
               };
               break;
            case 4:
               if (this.servicio_sel.num_pasajeros <= 0) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Indique la cantidad de pasajeros",
                  });
                  return false;
               }
               if (this.servicio_sel.origen == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de origen",
                  });
                  return false;
               }
               if (this.servicio_sel.destino == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de destino",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_ida == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de salida",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_regreso == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de regreso",
                  });
                  return false;
               }
               if (this.servicio_sel.proveedor == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione el proveedor del servicio",
                  });
                  return false;
               }
               servicio = {
                  tipo: this.servicio_sel.tipo,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  tipo_tiquete: this.servicio_sel.tipo_tiquete,
                  num_pasajeros: this.servicio_sel.num_pasajeros,
                  origen: this.servicio_sel.origen.id_ciudad,
                  destino: this.servicio_sel.destino.id_ciudad,
                  fecha_ida: this.servicio_sel.fecha_ida.sf,
                  fecha_regreso: this.servicio_sel.fecha_regreso.sf,
                  id_proveedor: this.servicio_sel.proveedor.id_proveedor,
                  valor_neto: this.servicio_sel.valor_neto,
                  valor_venta: this.servicio_sel.valor_venta,
               };
               break;
            case 5:
               if (this.servicio_sel.num_pasajeros <= 0) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Indique la cantidad de pasajeros",
                  });
                  return false;
               }
               if (this.servicio_sel.origen == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de origen",
                  });
                  return false;
               }
               if (this.servicio_sel.destino == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la ciudad de destino",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_ida == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de salida",
                  });
                  return false;
               }
               if (this.servicio_sel.fecha_regreso == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione la fecha de regreso",
                  });
                  return false;
               }
               if (this.servicio_sel.proveedor == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Seleccione el proveedor del servicio",
                  });
                  return false;
               }
               servicio = {
                  tipo: 5,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  num_pasajeros: this.servicio_sel.num_pasajeros,
                  origen: this.servicio_sel.origen.id_ciudad,
                  destino: this.servicio_sel.destino.id_ciudad,
                  fecha_ida: this.servicio_sel.fecha_ida.sf,
                  fecha_regreso: this.servicio_sel.fecha_regreso.sf,
                  id_proveedor: this.servicio_sel.proveedor.id_proveedor,
                  valor_neto: this.servicio_sel.valor_neto,
                  valor_venta: this.servicio_sel.valor_venta,
               };
               break;
            case 6:
               if (this.servicio_sel.descripcion == null) {
                  this.$notify({
                     group: "foo",
                     type: "error",
                     title: "Nueva reserva",
                     text: "Digita la descripción del servicio",
                  });
                  return false;
               }

               var fechaActividad =
                  this.servicio_sel.fecha_actividad != null
                     ? this.servicio_sel.fecha_actividad.sf
                     : null;

               servicio = {
                  tipo: this.servicio_sel.tipo,
                  id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
                  descripcion: this.servicio_sel.descripcion,
                  incluye: this.servicio_sel.incluye,
                  adultos: this.servicio_sel.adultos,
                  ninos: this.servicio_sel.ninos,
                  infantes: this.servicio_sel.infantes,
                  fecha_actividad: fechaActividad,
                  valor_neto: this.servicio_sel.valor_neto,
                  valor_venta: this.servicio_sel.valor_venta,
               };
               break;
         }
         if (servicio == null) {
            return false;
         }
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            servicio: servicio,
         };
         axios
            .post(this.$base_url + "reservas/update_servicio", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Editar reserva",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal").click();
                  vm.servicio_sel = null;
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally();
      },
      delete_servicio: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_servicio_reserva: this.servicio_sel.id_servicio_reserva,
         };
         axios
            .post(this.$base_url + "reservas/delete_servicio", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Editar reserva",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_eliminar").click();
                  vm.servicio_sel = null;
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally();
      },
      load_edicion: function (index) {
         this.servicio_sel = this.reserva.servicios[index];
         switch (Number(this.servicio_sel.tipo)) {
            case 1:
               this.get_horarios(this.servicio_sel.servicio.id_servicio);
               this.get_actividades();
               break;
         }
      },
      get_horarios: function (id_servicio) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(
               vm.$base_url + "servicios/horarios_servicio/" + id_servicio,
               config,
               {
                  headers: headers,
               },
            )
            .then((response) => {
               if (response.data.status) {
                  vm.horarios = response.data.data.horarios;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Horarios",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Horarios",
                  text: error,
               });
               vm.loading = false;
            });
      },
      get_proveedores: function (search) {
         if (search.length < 3) {
            return false;
         }
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
               tipo: this.servicio_sel.tipo,
            },
         };
         axios
            .get(vm.$base_url + "proveedores/proveedores", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.proveedores = response.data.data.proveedores;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Actividades",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Actividades",
                  text: error,
               });
               vm.loading = false;
            });
      },
      get_ciudades: function (search) {
         if (search.length < 3) {
            return false;
         }
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
            },
         };
         axios
            .get(vm.$base_url + "destinos/ciudades", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.ciudades = response.data.data.ciudades;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Actividades",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Actividades",
                  text: error,
               });
               vm.loading = false;
            });
      },
      set_pago: function () {
         const vm = this;

         if (this.nuevo_pago.valor == 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar pago",
               text: "El valor debe ser mayor a cero.",
            });
            return false;
         }
         if (
            (this.nuevo_pago.medio == 1 && this.nuevo_pago.cuenta == null) ||
            this.nuevo_pago.cuenta == "null"
         ) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar pago",
               text: "Por favor selecciona la cuenta a donde se realizó la consignación o transferencia.",
            });
            return false;
         }
         if (this.nuevo_pago.medio == 5 && this.nuevo_pago.bono == null) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar pago",
               text: "Por favor digita el código del bono a aplicar.",
            });
            return false;
         }
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            pago: this.nuevo_pago,
         };
         axios
            .post(this.$base_url + "reservas/set_pago", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.nuevo_pago = {
                     medio: 1,
                     cuenta: null,
                     fecha: new Date().toISOString().slice(0, 10),
                     valor: 0,
                  };

                  if (this.file.length != 0) {
                     vm.upload_soporte_pago(response.data.data.id_pago);
                  } else {
                     vm.$notify({
                        group: "foo",
                        type: "success",
                        title: "Agregar pago",
                        text: response.data.message,
                     });
                     document.getElementById("close_modal_pago").click();
                     vm.servicio_sel = null;
                     vm.get_reserva();
                  }
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      upload_soporte_pago: function (idPago) {
         this.hay_archivo = false;
         this.loading = true;
         var formData = new FormData();
         formData.append("files", this.file[0]);
         formData.append("token", this.session.usuario.token_session);
         formData.append("id_pago", idPago);
         const vm = this;
         axios
            .post(this.$base_url + "upload/soportePago", formData, {
               headers: {
                  "Content-Type": "multipart/form-data",
               },
            })
            .then((response) => {
               if (response.data.status) {
                  vm.hay_archivo = false;
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Excelente!",
                     text: "Se ha agregado el pago.",
                  });
                  vm.titulo_archivo = null;
                  vm.$refs.input_file_soport.value = null;
                  vm.loading = false;
                  vm.file = [];
                  document.getElementById("close_modal_pago").click();
                  vm.get_reserva();
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Ups!",
                     text: response.data.message,
                  });
                  vm.loading = false;
                  vm.file = [];
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Ups",
                  text: error,
               });
               console.log(error);
               vm.loading = false;
            });
      },
      delete_pago: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_pago: this.pago_sel.id_pago,
         };
         axios
            .post(this.$base_url + "reservas/delete_pago", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar pago",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_eliminar_pago").click();
                  vm.pago_sel = null;
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      aprobar_reserva: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
         };
         axios
            .post(this.$base_url + "reservas/aprobar_reserva", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Aprobar reserva",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_aprobar").click();

                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally();
      },
      enviar_email: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            email: this.reserva.cliente.email,
         };
         axios
            .post(this.$base_url + "reservas/enviar_email", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Enviar",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_enviar").click();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      cambiar_estado_review: function (review) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_review: review.id_review,
            estado: review.estado,
         };
         axios
            .post(this.$base_url + "reservas/update_review", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Reviews",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_enviar").click();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      delete_descuento: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
         };
         axios
            .post(this.$base_url + "reservas/quitar_descuento", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Enviar",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally();
      },
      get_hoteles: function (search) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
            },
         };
         axios
            .get(vm.$base_url + "servicios/hoteles_list", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.hoteles = response.data.data.hoteles;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            });
      },
      handle_images(e) {
         var files = e.target.files || e.dataTransfer.files;
         if (!files.length) {
            this.hay_archivo = false;
            return;
         }
         this.file = files;
         this.hay_archivo = true;
      },
      upload_voucher: function () {
         this.hay_archivo = false;
         this.loading = true;
         var formData = new FormData();
         formData.append("files", this.file[0]);
         formData.append("token", this.session.usuario.token_session);
         formData.append(
            "id_servicio_reserva",
            this.reserva.servicios[this.index_servicio_sel].id_servicio_reserva,
         );
         formData.append("titulo", this.titulo_archivo);
         const vm = this;
         axios
            .post(this.$base_url + "upload/voucher", formData, {
               headers: {
                  "Content-Type": "multipart/form-data",
               },
            })
            .then((response) => {
               if (response.data.status) {
                  vm.hay_archivo = false;
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Excelente!",
                     text: "Se ha subido el archivo.",
                  });
                  vm.titulo_archivo = null;
                  vm.$refs.input_file.value = null;
                  vm.loading = false;
                  vm.get_reserva();
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Ups!",
                     text: response.data.message,
                  });
                  vm.loading = false;
                  vm.file = [];
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Ups",
                  text: error,
               });
               console.log(error);
               vm.loading = false;
            });
      },
      delete_voucher: function (id_voucher) {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_voucher: id_voucher,
         };
         axios
            .post(this.$base_url + "reservas/delete_voucher", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar pago",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      set_nota: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            nota: this.nueva_nota,
         };
         axios
            .post(this.$base_url + "reservas/set_nota", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Agregar pago",
                     text: response.data.message,
                  });
                  vm.nueva_nota = {
                     nota: null,
                     tipo: 0,
                  };
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      set_pasajero: function () {
         this.reserva.pasajeros.push({
            id_pasajero: null,
            nombres: null,
            apellidos: null,
         });
      },
      eliminar_pasajero: function (index) {
         this.reserva.pasajeros.splice(index, 1);
      },
      update_pasajeros: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            pasajeros: this.reserva.pasajeros,
         };
         axios
            .post(this.$base_url + "reservas/update_pasajeros", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Pasajeros",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_pasajeros").click();
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      anular_reserva: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
         };
         axios
            .post(this.$base_url + "reservas/anular_reserva", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Agregar pago",
                     text: response.data.message,
                  });
                  vm.nueva_nota = null;
                  document.getElementById("close_modal_anular").click();
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      getCuentasBancarias: function (valida = true) {
         this.cuentas = [];
         if (this.nuevo_pago.medio != 1 && valida) {
            return false;
         }
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(vm.$base_url + "admin/cuentas", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  let cuentas = response.data.data.cuentas;
                  cuentas.forEach((cuenta) => {
                     if (cuenta.estado == 1) {
                        vm.cuentas.push(cuenta);
                     }
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Cuentas bancarias",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Cuentas bancarias",
                  text: error,
               });
               vm.loading = false;
            });
      },
      validarValorBono: function () {
         if (this.reserva.bonos.length > 0) {
            let bonos = this.reserva.bonos;
            let saldosBonos = 0;
            bonos.forEach((bono) => {
               saldosBonos = parseInt(saldosBonos) + parseInt(bono.valor);
            });
            this.valorMaxBono =
               parseInt(this.reserva.total_pagos) - parseInt(saldosBonos);
         } else {
            this.valorMaxBono = this.reserva.total_pagos;
         }

         this.nuevoBono.valor = this.valorMaxBono;
      },
      setBono: function () {
         if (this.nuevoBono.valor > this.valorMaxBono) {
            this.$notify({
               group: "foo",
               type: "error",
               title: "Error",
               text: "El valor del bono no puede ser mayor al saldo disponible.",
            });
            return false;
         }

         if (this.nuevoBono.valor <= 0) {
            this.$notify({
               group: "foo",
               type: "error",
               title: "Error",
               text: "El valor del bono debe ser mayor a cero.",
            });
            return false;
         }

         this.loading = true;

         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            bono: this.nuevoBono,
         };
         axios
            .post(this.$base_url + "reservas/setBono", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Crear bono",
                     text: response.data.message,
                  });

                  vm.nuevoBono = {
                     tipo: 0,
                     valor: 0,
                  };

                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            })
            .finally();
      },
      deleteBono: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idBono: this.bonoSel.id_bono,
         };
         axios
            .post(this.$base_url + "reservas/deleteBono", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar bono",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_eliminar_bono").click();
                  vm.bonoSel = null;
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            })
            .finally();
      },
      set_pago_proveedor: function () {
         const vm = this;

         if (this.nuevo_pago_proveedor.valor == 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar pago",
               text: "El valor debe ser mayor a cero.",
            });
            return false;
         }
         if (
            (this.nuevo_pago_proveedor.medio == 1 &&
               this.nuevo_pago_proveedor.cuenta == null) ||
            this.nuevo_pago_proveedor.cuenta == "null"
         ) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar pago",
               text: "Por favor selecciona la cuenta a donde se realizó la consignación o transferencia.",
            });
            return false;
         }
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.reserva.id_reserva,
            id_servicio_reserva:
               this.reserva.servicios[this.index_servicio_sel]
                  .id_servicio_reserva,
            id_proveedor:
               this.reserva.servicios[this.index_servicio_sel].proveedor
                  .id_proveedor,
            pago: this.nuevo_pago_proveedor,
         };
         axios
            .post(this.$base_url + "reservas/set_pago_proveedor", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.nuevo_pago_proveedor = {
                     medio: 1,
                     cuenta: null,
                     fecha: new Date().toISOString().slice(0, 10),
                     valor: 0,
                  };

                  if (this.file.length != 0) {
                     vm.upload_soporte_pago_proveedor(
                        response.data.data.id_pago,
                     );
                  } else {
                     vm.$notify({
                        group: "foo",
                        type: "success",
                        title: "Agregar pago",
                        text: response.data.message,
                     });
                     document.getElementById("close_modal_pago").click();
                     vm.servicio_sel = null;
                     vm.get_reserva();
                  }
               }
            })
            .catch((error) => {
               vm.loading = false;
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      upload_soporte_pago_proveedor: function (idPago) {
         this.hay_archivo = false;
         this.loading = true;
         var formData = new FormData();
         formData.append("files", this.file[0]);
         formData.append("token", this.session.usuario.token_session);
         formData.append("id_pago", idPago);
         const vm = this;
         axios
            .post(this.$base_url + "upload/soportePagoProveedor", formData, {
               headers: {
                  "Content-Type": "multipart/form-data",
               },
            })
            .then((response) => {
               if (response.data.status) {
                  vm.hay_archivo = false;
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Excelente!",
                     text: "Se ha agregado el pago.",
                  });
                  vm.titulo_archivo = null;
                  vm.$refs.input_file_soport.value = null;
                  vm.loading = false;
                  vm.file = [];
                  document.getElementById("close_modal_pago").click();
                  vm.get_reserva();
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Ups!",
                     text: response.data.message,
                  });
                  vm.loading = false;
                  vm.file = [];
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Ups",
                  text: error,
               });
               console.log(error);
               vm.loading = false;
            });
      },
      deletePagoProveedor: function (idPagoProveedor) {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idReserva: this.reserva.id_reserva,
            idPagoProveedor: idPagoProveedor,
         };
         axios
            .post(this.$base_url + "reservas/deletePagoProveedor", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar pago",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            })
            .finally();
      },
      setRecaudo: function () {
         const vm = this;

         if (this.nuevo_recaudo.valor == 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar recaudo",
               text: "El valor debe ser mayor a cero.",
            });
            return false;
         }
         if (
            this.nuevo_recaudo.cuenta == null ||
            this.nuevo_recaudo.cuenta == "null"
         ) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Agregar recaudo",
               text: "Por favor selecciona la cuenta bancaria.",
            });
            return false;
         }
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.reserva.id_reserva,
            id_servicio_reserva:
               this.reserva.servicios[this.index_servicio_sel]
                  .id_servicio_reserva,
            recaudo: this.nuevo_recaudo,
         };
         axios
            .post(this.$base_url + "reservas/setRecaudo", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.nuevo_pago_proveedor = {
                     medio: 1,
                     cuenta: null,
                     fecha: new Date().toISOString().slice(0, 10),
                     valor: 0,
                  };

                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Agregar recaudo",
                     text: response.data.message,
                  });
                  vm.servicio_sel = null;
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.loading = false;
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      deleteRecaudo: function (idRecaudo) {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idReserva: this.reserva.id_reserva,
            idRecaudo: idRecaudo,
         };
         axios
            .post(this.$base_url + "reservas/deleteRecaudo", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
                  vm.loading = false;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar recaudo",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            })
            .finally();
      },
      confirmCheck() {
         let msg = `¿Deseas marcar la reserva como 'Revisada' ?`;

         if (this.reserva.revisada == 1) {
            msg = `¿Deseas marcar la reserva como 'No revisada' ?`;
         }

         this.$swal
            .fire({
               title: "",
               html: msg,
               icon: "question",
               showCancelButton: true,
               buttonsStyling: false,
               confirmButtonText: "Sí",
               cancelButtonText: "No",
               customClass: {
                  confirmButton: "btn btn-success rounded-pill me-2",
                  cancelButton: "btn btn-light rounded-pill",
               },
            })
            .then((result) => {
               if (result.isConfirmed) {
                  this.checkReserva();
               }
            });
      },
      checkReserva() {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_reserva: this.id_reserva,
            check: this.reserva.revisada == 1 ? 0 : 1,
         };
         axios
            .post(this.$base_url + "reservas/check_reserva", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Revisada",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally(() => {
               vm.loading = false;
            });
      },
      generarVouchers() {
         if (this.serviciosVouchers.length == 0) {
            this.$notify({
               group: "foo",
               type: "warning",
               title: "Advertencia",
               text: "Selecciona al menos un servicio para generar los vouchers.",
            });
            return false;
         }

         this.loading = true;

         const vm = this;

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            servicios: this.serviciosVouchers,
         };
         axios
            .post(this.$base_url + "reservas/generar_vouchers", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Revisada",
                     text: response.data.message,
                  });
                  vm.get_reserva();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally(() => {
               vm.loading = false;
            });
      },
      getTasks() {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(
               vm.$base_url + "reservas/get_tasks_reserva/" + this.id_reserva,
               config,
               {
                  headers: headers,
               },
            )
            .then((response) => {
               if (response.data.status) {
                  vm.tasks = response.data.data.tasks;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            });
      },
      isTaskCompleted(task) {
         return Number(task.status) === 1;
      },
      updateStatusTask(task, checked) {
         const vm = this;
         const prevStatus = task.status;
         task.status = checked ? 1 : 0;

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };

         let params = {
            task: task,
         };

         axios
            .post(this.$base_url + "reservas/updateStatusTask", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  task.status = prevStatus;
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Tareas",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Tareas",
                     text: response.data.message,
                  });
                  vm.getTasks();
               }
            })
            .catch((error) => {
               task.status = prevStatus;
               vm.error_manager(error);
            })
            .finally();
      },
      setTask() {
         const vm = this;

         if (
            vm.nueva_tarea.description == null ||
            vm.nueva_tarea.description.trim().length == 0
         ) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Tareas",
               text: "La descripción de la tarea es obligatoria.",
            });
            return false;
         }

         if (vm.nueva_tarea.due_date == null || vm.nueva_tarea.due_date == "") {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Tareas",
               text: "La fecha de vencimiento es obligatoria.",
            });
            return false;
         }

         const today = new Date();
         today.setHours(0, 0, 0, 0);
         const dueDate = new Date(vm.nueva_tarea.due_date + "T00:00:00");

         if (dueDate <= today) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Tareas",
               text: "La fecha de vencimiento debe ser futura.",
            });
            return false;
         }

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };

         let params = {
            id_reserva: this.id_reserva,
            description: vm.nueva_tarea.description.trim(),
            date: vm.nueva_tarea.due_date,
         };

         axios
            .post(this.$base_url + "reservas/setTaskReserva", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Tareas",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Tareas",
                     text: response.data.message,
                  });

                  vm.nueva_tarea = {
                     description: null,
                     due_date: new Date().toISOString().slice(0, 10),
                  };

                  document.getElementById("close_modal_task").click();
                  vm.getTasks();
               }
            })
            .catch((error) => {
               vm.error_manager(error);
            })
            .finally();
      },
      error_manager: function (error) {
         let vm = this;
         let message = error;
         if (
            error.response.status != undefined &&
            error.response.status == 401
         ) {
            message = error.response.data.message;
            localStorage.removeItem("sess_vyt_backoffice");
            location.reload();
         }
         vm.$notify({
            group: "foo",
            type: "error",
            title: "Error",
            text: message,
         });
      },
   },
   watch: {
      $route() {
         this.id_reserva = this.$route.params.id_reserva;
         this.get_reserva();
      },
   },
};
</script>
